import { Box, Card } from "@mui/material";
import styles from '../clientPreorder/ClientPreOrder.module.scss';
import AppLogo from "../../components/common/appLogo/AppLogo";
import TitleSubtitle from "../../components/common/formControls/titleSubtitle/TitleSubtitle";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SuccessButton from "../../components/common/formControls/buttons/SuccessButton";

export default function ClientPreOrderSuccess (){
    const {t} = useTranslation();
    const navigate = useNavigate();

    const onBackButtonClick = () => {
        navigate("/svc");
    }

    return <Box className={[styles.centered].join(" ")}>
        <Box className={styles.internalContainerColumn}>
            <Card>
                <Box className={styles.verticalContainer}>
                    <AppLogo/>
                    <TitleSubtitle title={t("PREORDER_SUCCESS")} subTitle={t("PREORDER_NOTE")}/>
                    <SuccessButton id={"successfullyCreatedPreOrder"} label={t("BACK")} onclickHandler={onBackButtonClick}  />
                </Box>
            </Card>
        </Box>
    </Box>
}